import script from "./PeriodSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./PeriodSelector.vue?vue&type=script&setup=true&lang=ts"

import "./PeriodSelector.vue?vue&type=style&index=0&id=156f938b&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-156f938b"]])

export default __exports__